/** Set-password page strings, merged into the app's translation namespace on import. */
import i18n from '@/app/i18n'

const en = {
    'setpw.title': 'Set your password',
    'setpw.for': 'For {{email}}',
    'setpw.checking': 'Checking the link…',
    'setpw.new': 'New password',
    'setpw.repeat': 'Repeat the password',
    'setpw.hint': 'At least {{count}} characters. A short sentence makes a good password.',
    'setpw.submit': 'Set password',
    'setpw.saving': 'Saving…',
    'setpw.mismatch': 'The passwords do not match.',
    'setpw.doneTitle': 'Your password is set',
    'setpw.done': 'Sign in with {{email}} and your new password.',
    'setpw.signIn': 'Sign in',
    'setpw.error.link_invalid': 'This link is not valid. Ask your administrator for a new one.',
    'setpw.error.link_used': 'This link has already been used. If you need a new password, ask your administrator for a new link.',
    'setpw.error.link_expired': 'This link has expired. Ask your administrator for a new one.',
    'setpw.error.password_length': 'The password needs at least {{count}} characters.',
    'setpw.error.password_is_email': 'Choose something other than your e-mail address.',
    'setpw.error.failed': 'The password could not be set. Try again.',
}

const et: typeof en = {
    'setpw.title': 'Määra oma parool',
    'setpw.for': 'Kasutajale {{email}}',
    'setpw.checking': 'Kontrollin linki…',
    'setpw.new': 'Uus parool',
    'setpw.repeat': 'Korda parooli',
    'setpw.hint': 'Vähemalt {{count}} tähemärki. Lühike lause on hea parool.',
    'setpw.submit': 'Määra parool',
    'setpw.saving': 'Salvestan…',
    'setpw.mismatch': 'Paroolid ei ühti.',
    'setpw.doneTitle': 'Parool on määratud',
    'setpw.done': 'Logi sisse e-postiga {{email}} ja uue parooliga.',
    'setpw.signIn': 'Logi sisse',
    'setpw.error.link_invalid': 'See link ei kehti. Küsi administraatorilt uus.',
    'setpw.error.link_used': 'Seda linki on juba kasutatud. Kui vajad uut parooli, küsi administraatorilt uus link.',
    'setpw.error.link_expired': 'Selle lingi kehtivus on lõppenud. Küsi administraatorilt uus.',
    'setpw.error.password_length': 'Parool vajab vähemalt {{count}} tähemärki.',
    'setpw.error.password_is_email': 'Vali midagi muud kui oma e-posti aadress.',
    'setpw.error.failed': 'Parooli ei õnnestunud määrata. Proovi uuesti.',
}

const de: typeof en = {
    'setpw.title': 'Passwort festlegen',
    'setpw.for': 'Für {{email}}',
    'setpw.checking': 'Link wird geprüft…',
    'setpw.new': 'Neues Passwort',
    'setpw.repeat': 'Passwort wiederholen',
    'setpw.hint': 'Mindestens {{count}} Zeichen. Ein kurzer Satz ist ein gutes Passwort.',
    'setpw.submit': 'Passwort festlegen',
    'setpw.saving': 'Wird gespeichert…',
    'setpw.mismatch': 'Die Passwörter stimmen nicht überein.',
    'setpw.doneTitle': 'Ihr Passwort ist festgelegt',
    'setpw.done': 'Melden Sie sich mit {{email}} und Ihrem neuen Passwort an.',
    'setpw.signIn': 'Anmelden',
    'setpw.error.link_invalid': 'Dieser Link ist ungültig. Bitten Sie Ihren Administrator um einen neuen.',
    'setpw.error.link_used': 'Dieser Link wurde bereits verwendet. Für ein neues Passwort bitten Sie Ihren Administrator um einen neuen Link.',
    'setpw.error.link_expired': 'Dieser Link ist abgelaufen. Bitten Sie Ihren Administrator um einen neuen.',
    'setpw.error.password_length': 'Das Passwort braucht mindestens {{count}} Zeichen.',
    'setpw.error.password_is_email': 'Wählen Sie etwas anderes als Ihre E-Mail-Adresse.',
    'setpw.error.failed': 'Das Passwort konnte nicht festgelegt werden. Bitte erneut versuchen.',
}

const ru: typeof en = {
    'setpw.title': 'Задайте пароль',
    'setpw.for': 'Для {{email}}',
    'setpw.checking': 'Проверяем ссылку…',
    'setpw.new': 'Новый пароль',
    'setpw.repeat': 'Повторите пароль',
    'setpw.hint': 'Не менее {{count}} символов. Короткая фраза — хороший пароль.',
    'setpw.submit': 'Задать пароль',
    'setpw.saving': 'Сохраняем…',
    'setpw.mismatch': 'Пароли не совпадают.',
    'setpw.doneTitle': 'Пароль задан',
    'setpw.done': 'Войдите с адресом {{email}} и новым паролем.',
    'setpw.signIn': 'Войти',
    'setpw.error.link_invalid': 'Ссылка недействительна. Попросите у администратора новую.',
    'setpw.error.link_used': 'Эта ссылка уже использована. Если нужен новый пароль, попросите у администратора новую ссылку.',
    'setpw.error.link_expired': 'Срок действия ссылки истёк. Попросите у администратора новую.',
    'setpw.error.password_length': 'Пароль должен содержать не менее {{count}} символов.',
    'setpw.error.password_is_email': 'Выберите что-то кроме своего адреса эл. почты.',
    'setpw.error.failed': 'Не удалось задать пароль. Попробуйте ещё раз.',
}

for (const [language, strings] of Object.entries({ en, et, de, ru })) {
    i18n.addResourceBundle(language, 'translation', strings, true, false)
}
